// Libraries
var React = require('react');

// Components
var OptaWidget = require('../../MDC/OptaWidget/OptaWidget');

// Styles
require('./PlayerSeasonStats.scss');

class PlayerSeasonStatsModule extends React.Component {
    
	render() {
        return (
            <div className="PlayerSeasonStats">
                <div className="PlayerSeasonStats__container">
                    <h2>Player Season Stats</h2>
                    <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
                </div>
            </div>)
    }
}
    
module.exports = PlayerSeasonStatsModule;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerSeasonStats/PlayerSeasonStatsModule.js